import { AlertVariants } from '@carboledger/ui';
import { ALLOCATION_STATUS } from './allocationStatus';

// The three terminal statuses each explain themselves with a banner instead of CTAs.
const BANNERS = Object.freeze({
  [ALLOCATION_STATUS.creditsRetired]: {
    variant: AlertVariants.info,
    messageKey: 'ALLOCATIONS_BANNER_CREDITS_RETIRED',
  },
  [ALLOCATION_STATUS.declarationRejected]: {
    variant: AlertVariants.error,
    messageKey: 'ALLOCATIONS_BANNER_DECLARATION_REJECTED',
  },
  [ALLOCATION_STATUS.revoked]: {
    variant: AlertVariants.warning,
    messageKey: 'ALLOCATIONS_BANNER_REVOKED',
  },
});

export const allocationBanner = (t, statusCode) => {
  const banner = BANNERS[statusCode];
  return banner ? { variant: banner.variant, message: t(banner.messageKey) } : null;
};
